import { TranslationKeys } from '@pascal/pascal-core';

export const globalTranslationKeys = Object.assign(TranslationKeys, {
  FAIRNESS_P1: 'FAIRNESS_P1',
  FAIRNESS_P2: 'FAIRNESS_P2',
  FAIRNESS_P3: 'FAIRNESS_P3',
  FAIRNESS_P4: 'FAIRNESS_P4',
  FAIRNESS_P5: 'FAIRNESS_P5',
  FAIRNESS_P6: 'FAIRNESS_P6',
  FAIRNESS_P7: 'FAIRNESS_P7',
  FAIRNESS_P8: 'FAIRNESS_P8',
  FAIRNESS_P9: 'FAIRNESS_P9',
  FAIRNESS_P10: 'FAIRNESS_P10',
  FAIRNESS_P11: 'FAIRNESS_P11',
  FAIRNESS_P12: 'FAIRNESS_P12',
  GAME_RULES_P1: 'GAME_RULES_P1',
  GAME_RULES_P2: 'GAME_RULES_P2',
  GAME_RULES_P3: 'GAME_RULES_P3',
  GAME_RULES_P4: 'GAME_RULES_P4',
  GAME_RULES_P5: 'GAME_RULES_P5',
  GAME_RULES_P6: 'GAME_RULES_P6',
  GAME_RULES_P7: 'GAME_RULES_P7',
  GAME_RULES_P8: 'GAME_RULES_P8',
  GAME_RULES_P9: 'GAME_RULES_P9',
  GAME_RULES_P10: 'GAME_RULES_P10',
  GAME_RULES_P11: 'GAME_RULES_P11',
  GAME_RULES_P12: 'GAME_RULES_P12',
  CANCELATION_MESSAGE_1: 'CANCELATION_MESSAGE_1',
  MALFUNCTION_MESSAGE_2: 'MALFUNCTION_MESSAGE_2',
  RTP: 'RTP',
  BetAmount: 'BET_AMOUNT',
  User: 'USER',
  Bet_1: 'BET_1',
  Odd: 'ODD',
  Payout: 'PAYOUT',
  RoundId: 'ROUND_ID',
  TargetMultiplier: 'TARGET_MULTIPLIER',
  Balance: 'BALANCE',
  LastWin: 'LAST_WIN',
  Stop: 'STOP',
  Bet: 'BET',
  PlayForReal: 'PLAY_FOR_REAL',
  WinChance: 'WIN_CHANCE',
  Win: 'WIN',
  Fairness: 'FAIRNESS',
  Check: 'CHECK',
  Reconnect: 'RECONNECT',
  ConnectionError: 'CONNECTION_ERROR',
  GameOpen: 'GAME_OPEN',
  Help: 'HELP',
  Home: 'HOME',
  Bets: 'BETS',
  History: 'HISTORY',
  Settings: 'SETTINGS',
  Rules: 'RULES',
  OK: 'OK',
  OFF: 'OFF',
  ShowMore: 'SHOW_MORE',
  ShowLess: 'SHOW_LESS',
  YouWin: 'YOU_WIN',
  GameResult: 'GAME_RESULT',
  YourMultiplier: 'YOUR_MULTIPLIER',
  GAME_NAME: 'GAME_NAME',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  MIN_BET: 'MIN_BET',
  MAX_BET: 'MAX_BET',
  MAX_ODD: 'MAX_ODD',
  MAX_WIN: 'MAX_WIN',
  FREE_BET: 'Free Bet',
  MIN_ODD: 'MIN_ODD',
  MULTIPLIER_POP_UP_TITLE: 'MULTIPLIER_POP_UP_TITLE',
  MULTIPLIER_POP_UP_DESC: 'MULTIPLIER_POP_UP_DESC',
  CashOut: 'CASH_OUT',
  BONUS: 'BONUS',
  BONUS_DESC: 'BONUS_DESC',
});
